import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { serviceAreas } from "@/data/services";

const ServiceAreas = () => (
  <PageLayout>
    <Seo
      title="Service Areas Across Melbourne – Oz Property Services Co."
      description="We service Melbourne homes, rentals, shops, offices and commercial properties. Send your job details and we'll confirm availability."
      path="/service-areas"
    />
    <PageHero
      title="Property Services Across Melbourne"
      subtitle="We service Melbourne homes, rentals, shops, offices and commercial properties. If your suburb is nearby, send us your job details and we'll confirm availability."
    />
    <section className="bg-white py-16 md:py-24">
      <div className="container">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 max-w-4xl mx-auto">
          {serviceAreas.map((area) => (
            <div
              key={area}
              className="bg-card rounded-xl px-4 py-5 flex flex-col items-center text-center gap-2"
            >
              <div className="w-10 h-10 bg-yellow/15 rounded-full flex items-center justify-center">
                <MapPin className="w-5 h-5 text-dark" />
              </div>
              <span className="font-bold text-dark text-sm">{area}</span>
            </div>
          ))}
        </div>

        <p className="text-center text-muted-foreground mt-10 max-w-2xl mx-auto">
          Not listed? We cover many surrounding suburbs — get in touch and we'll let you know.
        </p>

        <div className="mt-10 text-center">
          <Link
            to="/get-quote"
            className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
          >
            Check My Suburb
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default ServiceAreas;
